import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AuthGuard} from '../shared/guards/auth.guard';
import {WizardGuard} from '../shared/guards/wizard.guard';
import {ProfileSettingsComponent} from './components/user-settings/profile-settings.component';
import {PricingGuard} from '../shared/guards/pricing.guard';

const routes: Routes = [
    {
        path: 'profile',
        component: ProfileSettingsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profile/:section',
        component: ProfileSettingsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SettingsRoutingModule {
}
